// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { TopicIndexViewModel } from './topicindexview-model';
import { SubAssignmentIndexViewModel } from './subassignmentindexview-model';

import { CheckType } from './enums';

export class AssignmentIndexViewModel {
    id: number = 0;
	order: number = 0;
	description: string = null;
	checkType: CheckType = CheckType.ShouldBeCreated;
	topicId: number = 0;
	topic: TopicIndexViewModel = null;
	subAssignments: SubAssignmentIndexViewModel[] = null;
	totalImportance: number = 0;
	totalScored: number = 0;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}